/* eslint-disable func-names */
/* eslint-disable no-undef */
const latestNews = () => {
  (function ($) {
    const $slick = $(".js-slick");
    const isHomepage = $(".c-latest-news--homepage").length;

    if (isHomepage) {
      return;
    }

    $slick.slick({
      infinite: false,
      mobileFirst: true,
      centerMode: true,
      centerPadding: "40px",
      responsive: [
        {
          breakpoint: 1600,
          settings: {
            slidesToShow: 5,
            slidesToScroll: 1,
            centerMode: false,
          },
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
            centerMode: false,
          },
        },
        {
          breakpoint: 1020,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            centerMode: false,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            centerMode: false,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: "40px",
          },
        },
      ],
    });
  })(jQuery);
};

export default latestNews;
